import { Component, Inject, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { AdminService } from '@banyan/modules/admin/services/admin.service';
import { SharedModule } from '@banyan/modules/shared/shared.module';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';

@Component({
  selector: 'app-admin-request-submit-modal',
  standalone: true,
  imports: [
    MatIcon,
    ReactiveFormsModule,
    SharedModule,
    ButtonComponent,
    DefaultCurrencyPipe
  ],
  templateUrl: './admin-request-submit-modal.component.html',
  styleUrl: './admin-request-submit-modal.component.scss',
})
export class AdminRequestSubmitModalComponent {
  adminService = inject(AdminService);
  constructor(
    public dialogRef: MatDialogRef<AdminRequestSubmitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  submitProducts() {
    this.adminService.submitRequest(this.data?.requestId, this.data?.endUseId);
    this.closeModal();
  }
}
